const Carousel = (()=>{

    let swiperInstance = null;
    // Video activo (uno a la vez): { player, platform, slide, controls, isPlaying, isMuted, seeking, progressTimer }
    let active = null;

    // ── Helpers ───────────────────────────────────────────────────────
    const fmt = (s)=>{
        const m   = Math.floor(s / 60);
        const sec = Math.floor(s % 60);
        return m + ':' + (sec < 10 ? '0' : '') + sec;
    };

    const fillSeek = (input, pct)=>{
        input.style.background = 'linear-gradient(to right, #0094FF ' + pct + '%, rgba(255,255,255,0.3) ' + pct + '%)';
    };

    const waitFor = (cond, cb)=>{
        if(cond()){ cb(); return; }
        const t = setInterval(()=>{
            if(cond()){ clearInterval(t); cb(); }
        }, 80);
    };

    // ── Cierra el video activo (destruye player y vuelve al poster) ──
    const closeActive = ()=>{
        if(!active) return;
        clearInterval(active.progressTimer);
        try {
            if(active.platform === 'vimeo' && active.player) active.player.unload();
            else if(active.platform === 'youtube' && active.player) active.player.destroy();
        } catch(_){}
        const host = active.slide.querySelector('.carousel-slide__player-host');
        if(host){ host.innerHTML = ''; host.classList.remove('yt-host'); }
        active.slide.removeAttribute('data-state');
        active = null;
    };

    // ── Pausa el video activo (sin destruirlo) ───────────────────────
    const pauseActive = ()=>{
        if(!active || !active.isPlaying) return;
        try {
            if(active.platform === 'vimeo' && active.player)   active.player.pause();
            else if(active.platform === 'youtube' && active.player) active.player.pauseVideo();
        } catch(_){}
    };

    // ── UI helpers ────────────────────────────────────────────────────
    const updatePlayUI = ()=>{
        if(!active) return;
        active.controls.iconPlay.style.display  = active.isPlaying ? 'none' : '';
        active.controls.iconPause.style.display = active.isPlaying ? '' : 'none';
    };

    const updateMuteUI = ()=>{
        if(!active) return;
        active.controls.iconSound.style.display = active.isMuted ? 'none' : '';
        active.controls.iconMuted.style.display = active.isMuted ? '' : 'none';
    };

    // ── Polling de progreso ──────────────────────────────────────────
    const startProgress = ()=>{
        if(!active) return;
        clearInterval(active.progressTimer);
        active.progressTimer = setInterval(()=>{
            if(!active || active.seeking || !active.player) return;
            try {
                if(active.platform === 'vimeo'){
                    active.player.getCurrentTime().then((cur)=>{
                        if(!active) return;
                        active.player.getDuration().then((dur)=>{
                            if(!active || !dur) return;
                            const pct = (cur / dur) * 100;
                            active.controls.seek.value = pct;
                            fillSeek(active.controls.seek, pct);
                            active.controls.time.textContent = fmt(cur) + ' / ' + fmt(dur);
                        });
                    });
                } else {
                    const cur = active.player.getCurrentTime();
                    const dur = active.player.getDuration();
                    if(!dur) return;
                    const pct = (cur / dur) * 100;
                    active.controls.seek.value = pct;
                    fillSeek(active.controls.seek, pct);
                    active.controls.time.textContent = fmt(cur) + ' / ' + fmt(dur);
                }
            } catch(_){}
        }, 400);
    };

    const stopProgress = ()=>{
        if(!active) return;
        clearInterval(active.progressTimer);
        active.progressTimer = null;
    };

    // ── Acciones de controles ────────────────────────────────────────
    const togglePlay = ()=>{
        if(!active || !active.player) return;
        try {
            if(active.platform === 'vimeo'){
                active.isPlaying ? active.player.pause() : active.player.play();
            } else {
                active.isPlaying ? active.player.pauseVideo() : active.player.playVideo();
            }
        } catch(_){}
    };

    const toggleMute = ()=>{
        if(!active || !active.player) return;
        active.isMuted = !active.isMuted;
        try {
            if(active.platform === 'vimeo'){
                active.player.setVolume(active.isMuted ? 0 : 1);
            } else {
                active.isMuted ? active.player.mute() : active.player.unMute();
            }
        } catch(_){}
        updateMuteUI();
    };

    const onSeek = ()=>{
        if(!active || !active.player) return;
        const pct = parseFloat(active.controls.seek.value) / 100;
        try {
            if(active.platform === 'vimeo'){
                active.player.getDuration().then((dur)=>{
                    if(active && active.player) active.player.setCurrentTime(dur * pct);
                });
            } else {
                active.player.seekTo(active.player.getDuration() * pct, true);
            }
        } catch(_){}
    };

    // ── Abre el video DENTRO del slide ────────────────────────────────
    const openVideoOnSlide = (slide)=>{
        // Si ya estaba activo otro slide, lo cerramos
        if(active && active.slide !== slide) closeActive();
        if(active && active.slide === slide) return; // ya está abierto

        const platform = slide.getAttribute('data-platform');
        const id       = slide.getAttribute('data-video-id');
        const host     = slide.querySelector('.carousel-slide__player-host');
        if(!platform || !id || !host) return;

        const controls = {
            play:      slide.querySelector('.cs-play'),
            mute:      slide.querySelector('.cs-mute'),
            seek:      slide.querySelector('.cs-seek'),
            time:      slide.querySelector('.cs-time'),
            iconPlay:  slide.querySelector('.cs-icon-play'),
            iconPause: slide.querySelector('.cs-icon-pause'),
            iconSound: slide.querySelector('.cs-icon-sound'),
            iconMuted: slide.querySelector('.cs-icon-muted'),
        };

        slide.setAttribute('data-state', 'playing');
        host.innerHTML = '';

        active = {
            player: null,
            platform: platform,
            slide: slide,
            controls: controls,
            isPlaying: false,
            isMuted: false,
            seeking: false,
            progressTimer: null
        };

        // Wire de controles (una sola vez por slide; replaceWith para limpiar listeners viejos)
        const wireBtn = (btn, handler)=>{
            const fresh = btn.cloneNode(true);
            btn.parentNode.replaceChild(fresh, btn);
            fresh.addEventListener('click', handler);
            return fresh;
        };
        controls.play = wireBtn(controls.play, togglePlay);
        controls.mute = wireBtn(controls.mute, toggleMute);
        // Re-link iconos tras el clone
        controls.iconPlay  = controls.play.querySelector('.cs-icon-play');
        controls.iconPause = controls.play.querySelector('.cs-icon-pause');
        controls.iconSound = controls.mute.querySelector('.cs-icon-sound');
        controls.iconMuted = controls.mute.querySelector('.cs-icon-muted');

        const freshSeek = controls.seek.cloneNode(true);
        controls.seek.parentNode.replaceChild(freshSeek, controls.seek);
        controls.seek = freshSeek;
        controls.seek.addEventListener('mousedown',  ()=>{ if(active) active.seeking = true; });
        controls.seek.addEventListener('touchstart', ()=>{ if(active) active.seeking = true; }, { passive: true });
        controls.seek.addEventListener('input',  ()=>{ fillSeek(controls.seek, controls.seek.value); });
        controls.seek.addEventListener('change', ()=>{ if(active) active.seeking = false; onSeek(); });

        // Inicializa el player según la plataforma
        if(platform === 'vimeo'){
            const iframe = document.createElement('iframe');
            iframe.setAttribute('allow', 'autoplay; fullscreen');
            iframe.setAttribute('allowfullscreen', '');
            iframe.src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&controls=0&background=0';
            host.appendChild(iframe);

            waitFor(()=> window.Vimeo && window.Vimeo.Player, ()=>{
                if(!active || active.slide !== slide) return;
                active.player = new window.Vimeo.Player(iframe);
                active.player.on('play',  ()=>{ if(active){ active.isPlaying = true;  updatePlayUI(); startProgress(); } });
                active.player.on('pause', ()=>{ if(active){ active.isPlaying = false; updatePlayUI(); stopProgress(); } });
                active.player.on('ended', ()=>{ if(active){ active.isPlaying = false; updatePlayUI(); stopProgress(); } });
                active.isPlaying = true;
                updatePlayUI();
                updateMuteUI();
            });
        } else if(platform === 'youtube'){
            host.classList.add('yt-host');
            const div = document.createElement('div');
            host.appendChild(div);

            waitFor(()=> window.YT && window.YT.Player, ()=>{
                if(!active || active.slide !== slide) return;
                active.player = new window.YT.Player(div, {
                    videoId: id,
                    playerVars: { autoplay: 1, controls: 0, modestbranding: 1, rel: 0, fs: 0, playsinline: 1 },
                    events: {
                        onReady: function(){
                            if(active){ active.isPlaying = true; updatePlayUI(); updateMuteUI(); startProgress(); }
                        },
                        onStateChange: function(e){
                            if(!active || !window.YT) return;
                            const S = window.YT.PlayerState;
                            if(e.data === S.PLAYING){
                                active.isPlaying = true;  updatePlayUI(); startProgress();
                            } else if(e.data === S.PAUSED || e.data === S.ENDED){
                                active.isPlaying = false; updatePlayUI(); stopProgress();
                            }
                        }
                    }
                });
            });
        }
    };

    // ── Init Swiper ──────────────────────────────────────────────────
    const initSwiper = ()=>{
        const container = document.querySelector('.carousel-swiper');
        if(!container) return;

        const captionText = document.querySelector('.carousel-caption-box p');
        const slides      = Array.from(container.querySelectorAll('.swiper-slide'));

        swiperInstance = new window.Swiper('.carousel-swiper', {
            slidesPerView: 1,
            speed: 600,
            grabCursor: true,
            navigation: {
                nextEl: '.carousel-nav--next',
                prevEl: '.carousel-nav--prev'
            },
            pagination: {
                el: '.carousel-pagination',
                clickable: true
            },
            on: {
                slideChange: function(){
                    pauseActive();
                    const slide = slides[this.realIndex] || slides[this.activeIndex];
                    if(!captionText || !slide) return;
                    const caption = slide.getAttribute('data-caption') || '';
                    captionText.style.opacity = '0';
                    setTimeout(()=>{
                        captionText.textContent = caption;
                        captionText.style.opacity = '1';
                    }, 220);
                }
            }
        });
    };

    // ── Wire de los botones "VER VIDEO" ──────────────────────────────
    const initVideoButtons = ()=>{
        document.querySelectorAll('.carousel-slide--video .carousel-slide__video-btn').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                e.stopPropagation();
                const slide = btn.closest('.carousel-slide--video');
                if(slide) openVideoOnSlide(slide);
            });
        });
    };

    return {
        childsCarousel: function(){
            if(!document.querySelector('#home-carousel')) return;
            waitFor(()=> window.Swiper, ()=>{
                initSwiper();
                initVideoButtons();
            });
        }
    };

})();

const getCarouselHandlers = ()=>{
    Carousel.childsCarousel();
}

export{
    getCarouselHandlers
}
